import { keyboard } from "./keyboard/index";

const userEvent = {
  keyboard,
};

export default userEvent;

export type { keyboardKey } from "./keyboard/index";
